//FOR HANDLING THE STUDENT SEARCH IS TRIGGER  FROM THE PATIENT LIST PAGE
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    searchTerm: ''
}   

const studentSearchSlice = createSlice({
    name: 'studentSearch',
    initialState,   
    reducers: {
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload
        }
    }
})

export const { setSearchTerm } = studentSearchSlice.actions
export default studentSearchSlice.reducer